import './Spinner.css';

export function Spinner() {
  return (
    <div className="spinner">
      <div className="active">
        <div className="a"></div>
        <div className="a b"></div>
      </div>
      <div className="track">
        <div className="a"></div>
        <div className="a b"></div>
      </div>
    </div>
  );
}
